//引入Vue
import Vue from "vue";
//引入App
import App from './App';
//引入vue-router
import VueRouter from "vue-router";
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'   //引入axios
import request from '../config/request'
import axiosRequest from '../config/axiosRequest.js'
import * as echarts from 'echarts';
import {isWeixin,isAlipay,isMobilePhone,isProduction} from "@/../config/deviceType"
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(ElementUI);
Vue.prototype.$axios = axios;//把axios挂载到vue上
Vue.prototype.$request = request
Vue.prototype.$axiosRequest = axiosRequest
Vue.prototype.$echarts = echarts;
Vue.prototype.$bus = new Vue(); // 事件总线
Vue.prototype.$isWeixin = isWeixin()
Vue.prototype.$isAlipay = isAlipay()
Vue.prototype.$isMobile = isMobilePhone()
Vue.prototype.$REDIRECT_PREFIX = isProduction()
Vue.prototype.$showHeader = true
//关闭Vue的生产提示
Vue.config.productionTip = false;
//应用vue-router插件
Vue.use(VueRouter);
Vue.use(preview);
Vue.mixin({
    computed:{
        userSuffix(){
            return '?userid=' + window.localStorage.getItem('userid') + '&token=' + window.localStorage.getItem('token');
        },
        companySuffix(){
            return '?userid=' + window.localStorage.getItem('userid') + '&token=' + window.localStorage.getItem('token') + '&companyId=' + this.companyId;
        }
    }
})

new Vue({
    el: '#app',
    render: h => h(App),
    router
});